export const SHOULD_RENDER = 'SHOULD_RENDER';
export const DISABLE_RENDER = 'DISABLE_RENDER';

export const shouldRender = () => ({type: SHOULD_RENDER});
export const disableRender = () => ({type: DISABLE_RENDER});
